module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-footer"
  }, [_c('div', {
    staticClass: "order-data-bar"
  }, [_c('div', {
    staticClass: "order-data-col"
  }, [_c('h5', [_c('img', {
    attrs: {
      "src": "/static/img/icons/map.svg",
      "alt": "",
      "height": "17"
    }
  }), _vm._v("\n\t\t\t\t" + _vm._s(_vm.dispatchName) + "\n\t\t\t")]), _vm._v(" "), (!!_vm.warehouseAddress) ? _c('p', [_vm._v("\n\t\t\t\t" + _vm._s(_vm.warehouseAddress) + "\n\t\t\t")]) : _c('p', [_vm._v("\n\t\t\t\t" + _vm._s(_vm.customer.fullName) + " " + _vm._s(_vm.customer.documentType) + ": " + _vm._s(_vm.customer.documentNumber) + "\n\t\t\t\tTeléfono: " + _vm._s(_vm.customer.phone) + " Dirección: " + _vm._s(_vm.customer.address) + "\n\t\t\t")])]), _vm._v(" "), (_vm.flagBill) ? _c('div', {
    staticClass: "order-data-col"
  }, [_c('h5', [_vm._v("Solicitud de Factura:")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\tRUC: " + _vm._s(_vm.billing.documentNumber) + " Razón Social: " + _vm._s(_vm.billing.rzSocial) + "\n\t\t\t\tDomicilio Fiscal: " + _vm._s(_vm.billing.address) + "\n\t\t\t")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "order-data-col"
  }, [_c('h5', [_vm._v("Método de Pago")]), _vm._v(" "), (_vm.paymentMethod) ? _c('p', [_vm._v("\n\t\t\t\t" + _vm._s(_vm.paymentMethod) + "\n\t\t\t")]) : _c('p', [_vm._v("\n\t\t\t\tTarjeta de Crédito o Débito\n\t\t\t")])])]), _vm._v(" "), _c('order-payment-data', {
    attrs: {
      "account-name": _vm.accountName,
      "account-number": _vm.accountNumber,
      "description": _vm.description,
      "gateway-transaction-id": _vm.gatewayTransactionId,
      "logo-bank": _vm.logoBank,
      "card-number": _vm.cardNumber,
      "succes": _vm.success
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e893ef0c","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/order-footer.vue
// module id = 1162
// module chunks = 2